import { Card, CardHeader, Col, Container } from "react-bootstrap"
import Layout from "../components/Layout"
import { useCounts } from "../hooks/counts"
import { Flex, H1 } from "@inmagik/magik-ui"

export const CardCount = ({ title, count }: { title: string; count: number | undefined }) => {
  return (
    <Card>
      <CardHeader className="bg-primary text-white">
        <Card.Title>{title}</Card.Title>
      </CardHeader>
      <Card.Body>
        <Card.Text>
          {count} {title}
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export function Home() {
  const { data: counts } = useCounts()
  return (
    <Layout>
      <H1>Dashboard</H1>
      <Container fluid className="mt-4">
        <Flex alignItems="center" justifyContent="between">
          <Col md={3}>
            <CardCount title="Opere" count={counts?.opere} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Persone" count={counts?.persone} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Edizioni" count={counts?.edizioni} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Immagini" count={counts?.immagini} />
          </Col>
        </Flex>
      </Container>
      <Container fluid className="mt-4">
        <Flex alignItems="center" justifyContent="between">
          <Col md={3}>
            <CardCount title="Paratesti" count={counts?.paratesti} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Esemplari" count={counts?.esemplari} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Facsimili" count={counts?.facsimili} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Biblioteche" count={counts?.biblioteche} />
          </Col>
        </Flex>
      </Container>
      <Container fluid className="mt-4">
        <Flex alignItems="center">
          <Col md={3}>
            <CardCount title="Città" count={counts?.citta} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Tags" count={counts?.tags} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Formati" count={counts?.formati} />
          </Col>
          <Col md={3} className="ms-2">
            <CardCount title="Tipologie Immagini" count={counts?.tipologie_immagini} />
          </Col>
        </Flex>
      </Container>
    </Layout>
  )
}
